


export const Footer = () => {

  return (
    <div className="opcv-footer">
      <div>made with 🥰 by gooday</div>
      <a href="https://github.com/baday19/OnePageCV">github</a>
      {/* <div>have a good day!</div> */}
    </div>
  )
}